import $ from "jquery";

const passwordtoggle = () => {
  const init = () => {
    action();
    addPasswordToggle();
  };

  const action = () => {
    const el = {
      button: ".AccountPage .toggle-password",
    };

    $(document).on("click", el.button, function () {
      $(this)
        .parent()
        .find("input")
        .attr("type", (_, type) => (type === "text" ? "password" : "text"));

      $(this).toggleClass("show");
    });
  };

  const addPasswordToggle = () => {
    const el = {
      field: ".AccountPage  div.b2bking_custom_registration_container.b2bking_custom_registration_role_8:nth-child(4) p.woocommerce-form-row",
      button: ".AccountPage  div.b2bking_custom_registration_container.b2bking_custom_registration_role_8:nth-child(4) .toggle-password",
    };


    $(function () {
      $(el.field).append(`<span class="toggle-password"><img src="/wp-content/themes/verstegen/assets/images/eye.svg" width="auto" height="auto" alt="icon eye"></span>`)
    })

    $(document).on("click", el.button, function () {
      let typeData = $(this).parent().find("input").attr("type")
      typeData === "text" ? $(this).find('img').attr('src', '/wp-content/themes/verstegen/assets/images/eye-off.svg') : $(this).find('img').attr('src', '/wp-content/themes/verstegen/assets/images/eye.svg')

    });

  };



  init();
};

try {
  passwordtoggle();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("password-toggle.js  =>", error);
}
